import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FulfillService } from '../../fulfill.service';
import { CarrierTypeNames } from '@pdqdev/pdq-shared/dist/CarrierData';
import { Address, TeamNote } from '@pdqdev/pdq-shared/dist/entities';

const trackEditSupportedCarriers = [CarrierTypeNames.SELF, CarrierTypeNames.SELF_PICKUP];

@Component({
  selector: 'fulfill-side-panel-order-info',
  templateUrl: './fulfill-side-panel-order-info.component.html',
  styleUrls: ['./fulfill-side-panel-order-info.component.scss'],
  standalone: false,
})
export class FulfillSidePanelOrderInfoComponent implements OnInit, OnChanges {
  @ViewChild('info') info;
  @Output() printOrder = new EventEmitter();
  @Input() printOptions = [];
  @Input() printSections = [];
  @Input() order;
  batch;
  tags = [];
  shipTo = { firstName: '', lastName: '', phone: '', company: '' };
  hasShipTo;
  shippingAddress;
  hasCustomerGroups;
  displayStat;
  teamNotes: TeamNote[] = [];
  maxTeamNotesDisplay: number = 1;
  showAllTeamNotes: boolean = false;
  customerGroups;
  isTrackingNumberEditingEnabled;
  isShowSuggestedAddressBanner = false;
  modifiedAddressBannerMessage: string | null = null;
  isPartialHistory = true;

  constructor(public fulfillService: FulfillService) {}
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.order) {
      this.initShowTracking();
      this.setTags();
      this.setInfo();
      this.initTeamNotesData();
      this.initCustomerProfile();
      this.initBanners(this.order);
    }
  }

  ngOnInit(): void {
    this.batch = this.fulfillService.activeBatch;
    this.initShowTracking();
    this.setTags();
    this.setInfo();
    this.initTeamNotesData();
    this.initCustomerProfile();
    this.initBanners(this.order);
  }

  initCustomerProfile() {
    const groupsArray = this.order.customer?.groups?.split(',');

    if (!groupsArray?.length) {
      return;
    }

    let trimmedGroupsArray: string[] = [];
    trimmedGroupsArray = groupsArray.map((group) => group?.trim());

    // backwards compatibility
    if (!trimmedGroupsArray.includes(this.order?.customer?.group1)) {
      trimmedGroupsArray.push(this.order?.customer?.group1);
    }

    if (!trimmedGroupsArray.includes(this.order?.customer?.group2)) {
      trimmedGroupsArray.push(this.order?.customer?.group2);
    }

    this.customerGroups = trimmedGroupsArray?.filter(Boolean);
  }
  initShowTracking() {
    const currentCarrier = this.order?.orderBatch?.selectedCarrier?.type?.name;
    this.isTrackingNumberEditingEnabled = trackEditSupportedCarriers.includes(currentCarrier);
  }
  setInfo() {
    if (this.order) {
      const { shippingFirstName, shippingLastName, shippingPhone, shippingAddress, customer } = this.order;

      this.shipTo.firstName = shippingFirstName ? shippingFirstName : null;
      this.shipTo.lastName = shippingLastName ? shippingLastName : null;
      this.shipTo.company = shippingAddress?.company ? shippingAddress.company : null;
      this.shipTo.phone = shippingPhone ? shippingPhone : null;
      this.shippingAddress = shippingAddress ? shippingAddress : {};

      this.hasShipTo = Object.values(this.shipTo).filter((x) => x).length;
      this.hasCustomerGroups =
        this.checkIfShouldDisplayOrdersCountChip(this.order) ||
        customer?.group1 ||
        customer?.group2 ||
        this.customerGroups?.length ||
        customer?.note;
    }
  }

  initTeamNotesData() {
    this.teamNotes = this.order.teamNotes;
    this.teamNotes?.sort((b: any, a: any) => Date.parse(a.createdAt) - Date.parse(b.createdAt));
  }

  // TODO separate html to section
  displayAllTeamNotes() {
    this.showAllTeamNotes = !this.showAllTeamNotes;

    if (this.showAllTeamNotes) {
      this.maxTeamNotesDisplay = this.teamNotes.length;
    } else {
      this.maxTeamNotesDisplay = 1;
    }
  }

  setTags() {
    this.tags = [];
    this.order.orderTags.forEach((tag) => this.tags.push(tag.name));
    this.order.orderItems.forEach((item) => {
      item.product.productTags?.forEach((tag) => {
        if (this.tags.every((existingTag) => existingTag.toLowerCase() !== tag.name.toLowerCase()))
          this.tags.push(tag.name);
      });
    });
  }

  checkIfShouldDisplayOrdersCountChip(order) {
    return this.fulfillService.checkIfShouldDisplayOrdersCountChip(order);
  }

  toggleDetails() {
    this.displayStat = getComputedStyle(this.info.nativeElement).display;
    if (this.displayStat === 'block') {
      this.info.nativeElement.style.display = 'none';
    } else {
      this.info.nativeElement.style.display = 'block';
    }
  }

  initBanners(activeOrder: any) {
    if (activeOrder?.suggestedShippingAddress && activeOrder?.deliveryTransaction?.isUsedSuggestedShippingAddress) {
      this.isShowSuggestedAddressBanner = true;

      const suggested: Address = activeOrder?.suggestedShippingAddress;
      const suggestedVals = [suggested.address1, suggested.city, suggested.province, suggested.country, suggested.zip];
      const suggestedString = suggestedVals.filter((val) => !!val).join(', ');
      this.modifiedAddressBannerMessage = `This order's shipping address was modified to the following: ${suggestedString}`;
    } else {
      this.isShowSuggestedAddressBanner = false;
      this.modifiedAddressBannerMessage = null;
    }
  }
}
